import { ApiClientService, EntityApiService, RequestConfig, SearchResponseType } from '@dfl/react-security';
import { OperatorFilter, TermFilter } from '@dofleini/query-builder';
import { ICausesIncidence } from 'modules/sales/settings/causes-incidence/interfaces';

const NULL_PARENT_FILTER = new TermFilter({ field: 'parent', value: null }).toQuery();

const SEARCH_PARENTS_FILTERS = new OperatorFilter({
  type: 'AND',
  filters: [NULL_PARENT_FILTER],
}).toQuery();

const NOT_NULL_PARENT_FILTER = new TermFilter({ field: 'parent', value: { $ne: null } }).toQuery();

const SEARCH_CHILDREN_FILTERS = new OperatorFilter({
  type: 'AND',
  filters: [NOT_NULL_PARENT_FILTER],
}).toQuery();

class CausesIncidenceService extends EntityApiService<ICausesIncidence> {
  searchClean = (params?: any, config?: RequestConfig): Promise<SearchResponseType<ICausesIncidence>> => {
    const projections = {
      createdAt: 0,
      isPublic: 0,
      description: 0,
      owner: 0,
      space: 0,
      notification: 0,
      sendNotification: 0,
      updatedAt: 0,
    };
    return this.search({ ...params, projections }, config);
  };

  searchParents = async (params?: any, config?: RequestConfig): Promise<SearchResponseType<ICausesIncidence>> => {
    params.filters = SEARCH_PARENTS_FILTERS;

    params.projections = {
      createdAt: 0,
      isPublic: 0,
      description: 0,
      owner: 0,
      space: 0,
      notification: 0,
      sendNotification: 0,
      updatedAt: 0,
    };
    params.sort = {
      parent: 1,
      order: 1,
    };
    return await this.search(params, config);
  };

  searchChildren = async (params?: any, config?: RequestConfig): Promise<SearchResponseType<ICausesIncidence>> => {
    params.filters = SEARCH_CHILDREN_FILTERS;

    params.projections = {
      createdAt: 0,
      isPublic: 0,
      description: 0,
      owner: 0,
      space: 0,
      notification: 0,
      sendNotification: 0,
      updatedAt: 0,
    };
    params.sort = {
      parent: 1,
      order: 1,
    };
    return await this.search(params, config);
  };

  updateStatus = (payload: Partial<ICausesIncidence>): any => {
    return ApiClientService.patch(this.getPath(`/${payload?._id as string}`), {
      ...payload,
    });
  };
}

export default new CausesIncidenceService('/ms-sales/api/causes-incidences');
